module.exports = __webpack_public_path__ + "static/media/S4CE.87e25400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S4CE.jpg
// module id = 92
// module chunks = 0